import React, {Component, Fragment} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleDoc from "../../../../modules/SimpleDoc";
import Api from "../../../../Services/Api";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import * as R from "ramda";

class MasterBBNUploadFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            warningModalVisible: false,
            typeWarning: 1,
            file: null,
        };
    }

    handleWarningModalVisibility = (text, typeWarning) => {
        this.setState((prevState) => ({
            ...prevState,
            warningMessage: text,
            typeWarning: R.isNil(typeWarning) ? 1 : typeWarning,
            warningModalVisible: !prevState.warningModalVisible,
        }))
    }

    handleDownloadTemplate = async () => {
        try {
            const res = await Api.create("NAGAMAS_MASTER_DATA_FILE").downloadTemplateBBN();
            if (res.ok) {
                // Convert response to Blob
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});

                // Create a download link
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "Master_BBN_Template.xlsx"; // Set the desired file name
                document.body.appendChild(a);
                a.click();

                // Cleanup
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    handleChangeFile = (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            [name]: value,
        }))
    }

    handleSubmitFile = async () => {
        try {
            if (R.or(R.isNil(this.state.file), R.isEmpty(this.state.file))) {
                this.handleWarningModalVisibility("File kosong. Silahkan input file terlebih dahulu.", 2);
                return;
            }

            this.handleTriggerLoading(); 

            const formData = new FormData();
            formData.append("file", this.state.file);
            let res = await Api.create("NAGAMAS_MASTER_DATA").uploadTemplateBBN(formData);

            const component = document.getElementById("inputFile");
            if (component && component.value) {
                component.value = "";
            }

            if (!res.ok) {
                this.handleWarningModalVisibility("Gagal upload file.");
                this.handleTriggerLoading(); 
                return;
            }

            const result = res.data?.data;
            if (!result) {
                this.handleWarningModalVisibility("Response tidak valid.");
                this.handleTriggerLoading(); // STOP
                return;
            }

            if (result.status === "F") {
                this.handleWarningModalVisibility(
                    "Terdapat kesalahan pengisian data upload. Mohon diperbaiki dan upload kembali kemudian."
                );
                this.handleTriggerLoading(); // STOP
                return;
            }

            if (result.status === "S") {
                const rawData = result.data || [];

                const transformedData = rawData.map(item => ({
                    kodeVariant: item["Kode Varian"],
                    namaVariant: item["Nama Varian"],
                    bbnPrice: item["Harga BBN"],
                    differenceIncomeBbn: item["Pendapatan Selisih BBN"]
                }));

                this.props.onChange(transformedData);
                this.handleTriggerLoading(); 
            }

        } catch (error) {
            console.log("error: ", error);
            this.handleTriggerLoading(); 
        }
    };

    downloadLogError = async () => {
        try {
            const res = await Api.create("NAGAMAS_MASTER_DATA_FILE").downloadLogErrorBBN();
            if (res.ok) {
                // Convert response to Blob
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});

                // Create a download link
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "Master_BBN_Log_Error.xlsx"; // Set the desired file name
                document.body.appendChild(a);
                a.click();

                // Cleanup
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    render() {
        return (
            <Fragment>
                <SimpleModal
                    title="Upload Tambah Tabel BBN"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <FlexView vAlignContent="center">
                                <div className="margin-5px">
                                    <div className="txt-site txt-11 txt-main txt-bold">
                                        <h4>
                                            Template file dapat diunduh
                                        </h4>
                                    </div>
                                </div>
                                <SimpleButton
                                    text="DISINI"
                                    onClick={this.handleDownloadTemplate}
                                    className="margin-top-5px"
                                />
                            </FlexView>

                            <FlexView vAlignContent="center" className="margin-bottom-20px margin-top-20px">
                                <SimpleDoc
                                    readOnly
                                    idInputFile="inputFile"
                                    onChange={(name, value) => this.handleChangeFile(name, value)}
                                />
                            </FlexView>

                            <FlexView hAlignContent="right" className="margin-bottom-20px margin-top-20px">
                                <SimpleButton
                                    text="Validasi & Unggah File"
                                    onClick={this.handleSubmitFile}
                                    className="margin-top-5px"
                                />
                            </FlexView>

                        </ModalContainer>
                    }
                />

                {this.state.warningModalVisible && (
                    <SimpleAlert
                        title={"Information"}
                        content={
                            <div>
                                <p>
                                    {this.state.warningMessage}
                                    <br/>
                                    Mohon periksa kembali.
                                </p>
                            </div>
                        }
                        visible={this.state.warningModalVisible}
                        onClickClose={this.handleWarningModalVisibility}
                        additionalButtons={
                            <FlexView vAlignContent={"center"} style={{justifyContent: "end", gap: "20px"}}>
                                <SimpleButton
                                    type="button"
                                    text="Tutup"
                                    onClick={() => this.handleWarningModalVisibility()}
                                />

                                {
                                    R.equals(this.state.typeWarning, 1) && (
                                        <SimpleButton
                                            type="button"
                                            text="Download Log Error"
                                            onClick={() => this.downloadLogError()}
                                        />
                                    )
                                }
                            </FlexView>

                        }
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </Fragment>
        );
    }
}

export default MasterBBNUploadFile;